import { UtilityBanner } from '@/components/site/UtilityBanner'
import { SiteHeader } from '@/components/site/SiteHeader'
import { HeroMap } from '@/components/site/HeroMap'
import { ApiCta } from '@/components/site/ApiCta'
import { Footer } from '@/components/site/Footer'

export function HomePage() {
  return (
    <div className="flex min-h-[100dvh] flex-col bg-[var(--color-surface)]">
      <UtilityBanner />
      <SiteHeader />
      <main className="flex-1">
        <HeroMap />
        <ApiCta />
      </main>
      <Footer />
    </div>
  )
}
